import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PackageCard from '../../../../components/customer/PublicCustomerScreens/PackagesComponent/PackageCard';
import CustomerLoginForm from '../../../../components/customer/PublicCustomerScreens/CustomerFormComponents/CustomerLoginForm';
import '../../../../assets/css/customer/publicCustomerCss/CusPackages/cuspackages.css';
import '../../../../assets/css/customer/publicCustomerCss/EventBlogs/eventblogs.css';
import AppContext from '../../../../context/AppContext';

const PackageListSubscreen = () => {

    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedCard, setExpanded] = useState(null);
    const [wishlistIds, setWishlistIds] = useState([]);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const { baseUrl, authToken } = useContext(AppContext);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        axios
            .get(`${baseUrl}/customer/view-cus-packages`)
            .then((response) => {
                setPackages(response.data?.data ?? []);
            })
            .catch((err) => {
                console.error('Fetch packages error:', err);
                navigate('/connection-lost');
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        if (!authToken) return;

        const currentCustomerId = Number(localStorage.getItem('customerId'));

        axios.get(`${baseUrl}/customer/wishlist`, {
            headers: { Authorization: `Bearer ${authToken}` }
        })
            .then((res) => {
                if (res.data.success) {
                    const packIds = res.data.data
                        .filter((item) => Number(item.jjcustomer_id) === currentCustomerId)
                        .filter((item) => item.jjpackage_id !== null)
                        .map((item) => Number(item.jjpackage_id));
                    setWishlistIds(packIds);
                }
            })
            .catch((err) => console.error('Fetch wishlist error:', err));
    }, [baseUrl, authToken]);

    const handleToggle = (id) => setExpanded(prev => (prev === id ? null : id));

    const handleWishlistToggle = (packId, e) => {
        e && e.stopPropagation();

        if (!authToken) {
            setShowLoginModal(true);
            return;
        }

        const numericPackId = Number(packId);
        const isWishlisted = wishlistIds.includes(numericPackId);

        if (isWishlisted) {
            axios.delete(`${baseUrl}/customer/wishlist/${numericPackId}?type=package`, {
                headers: { Authorization: `Bearer ${authToken}` }
            })
                .then(() => {
                    setWishlistIds((prev) => prev.filter((id) => id !== numericPackId));
                })
                .catch(() => {});
        } else {
            const formData = new FormData();
            formData.append('jjpackage_id', numericPackId);

            axios.post(`${baseUrl}/customer/addWishlist`, formData, {
                headers: { Authorization: `Bearer ${authToken}` }
            })
                .then(() => {
                    setWishlistIds((prev) => [...prev, numericPackId]);
                })
                .catch(() => {});
        }
    };

    if (loading) {
        return (
            <div className="pub-pack-packages-screen">
                <div className="pub-pack-state-center">
                    <div className="pub-pack-spinner" />
                    <p>Loading packages…</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="pub-pack-packages-screen">
                <div className="pub-pack-state-center pub-pack-state-error">
                    <p>⚠ {error}</p>
                    <button onClick={() => window.location.reload()}>Retry</button>
                </div>
            </div>
        );
    }

    if (!packages.length) {
        return (
            <div className="pub-pack-packages-screen">
                <div className="pub-pack-state-center">
                    <p>No packages available at the moment.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="pub-pack-packages-screen">
            <header className="eb-hero">
                <div className="eb-hero-dots" />
                <div className="eb-hero-content">
                    <span className="eb-hero-eyebrow">Northern Pakistan</span>
                    <h1 className="eb-hero-title">Travel Packages</h1>
                    <p className="eb-hero-sub">
                        Discover curated adventures in Hunza, Skardu, Gilgit, and beyond —
                        from family tours to thrill‑seeking treks.
                    </p>
                </div>
                <div className="eb-hero-wave">
                    <svg viewBox="0 0 1440 56" preserveAspectRatio="none">
                        <path d="M0,28 C480,56 960,0 1440,28 L1440,56 L0,56 Z" fill="#f2f5f8" />
                    </svg>
                </div>
            </header>

            <div className="pub-pack-grid-container">
                <div className="pub-pack-grid">
                    {packages.map(pkg => (
                        <div key={pkg.id} className="pub-pack-grid-item">
                            {/* ← YAHAN hai wo jagah jo aap puch rahe hain */}
                            <PackageCard
                                packageData={pkg}
                                onToggle={handleToggle}
                                isExpanded={expandedCard === pkg.id}
                                otherCardsShrink={false}
                                isWishlisted={wishlistIds.includes(Number(pkg.id))}
                                onWishlist={handleWishlistToggle}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {showLoginModal && (
                <CustomerLoginForm onClose={() => setShowLoginModal(false)} />
            )}
        </div>
    );
};

export default PackageListSubscreen;